export default __webpack_public_path__ + "static/typography-image-q-e5c9009626b279bad74887eab9367965.png";